// eslint-disable-next-line
import React, { useContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import StudentRosterCard from './StudentRosterCard';
import { localStateReducer } from '../../../../../../utils/common';
import { ResizeContext } from '../../../../../../context/ResizeContext';

interface StudentRosterColumnProps {
  columnType: string;
  emptyStateText: string;
  headerText: string;
  // eslint-disable-next-line
  studentStatusArray?: any[];
  toggleVisible?: (columnType: string) => void;
  visible: boolean;
}
export default function StudentRosterColumn({
  columnType = '',
  emptyStateText = '',
  headerText = '',
  studentStatusArray = [],
  toggleVisible = () => {},
  visible = false,
}: StudentRosterColumnProps) {
  const windowSize = useContext(ResizeContext);

  const [localState, setLocalState] = useReducer(localStateReducer, {
    isMobile: windowSize.mobile,
  });

  useEffect(() => {
    setLocalState({
      isMobile: windowSize.mobile,
    });
  }, [windowSize.mobile]);

  const a11yBtnProps = !localState.isMobile
    ? null
    : {
        'aria-expanded': visible,
      };

  const a11yContentProps = !localState.isMobile
    ? null
    : {
        'aria-hidden': !visible,
      };

  return (
    <table
      className={`student-roster-swimLane-col student-roster-single-swimLane-wrapper col-md-4 px-0 ${
        visible ? '' : 'student-roster-swimLane-hide'
      }`}
    >
      <thead>
        <tr>
          <th className='student-roster-swimLane-header' id={`roster-column-${columnType}-header`}>
            <div className={'hidden-xs hidden-sm'}>
              {headerText} ({studentStatusArray?.length || '0'})
            </div>
            <button
              className={'hidden-md-up'}
              onClick={() => toggleVisible(columnType)}
              aria-controls={`roster-column-${columnType}`}
              {...a11yBtnProps}
            >
              {headerText} ({studentStatusArray?.length || '0'})
            </button>
          </th>
        </tr>
      </thead>
      <tbody
        className={'collapsable'}
        id={`roster-column-${columnType}`}
        aria-labelledby={`roster-column-${columnType}-header`}
        {...a11yContentProps}
      >
        {studentStatusArray?.length > 0 ? (
          studentStatusArray.map((student) => (
            <tr key={`${columnType}-student-card-${student?.id}`}>
              <td className='student-roster-swimLane-container student-roster-swimLane-card'>
                <StudentRosterCard student={student} type={columnType} />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td>
              <div className='student-roster-swimLane-container student-roster-swimLane-desc'>{emptyStateText}</div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

StudentRosterColumn.propTypes = {
  columnType: PropTypes.string,
  emptyStateText: PropTypes.string,
  headerText: PropTypes.string,
  studentStatusArray: PropTypes.array,
  toggleVisible: PropTypes.func,
  visible: PropTypes.bool,
};
